import { FirestoreDataConverter } from 'firebase/firestore';

export default class ShopAuthority {
  constructor (
    readonly id: string,
    readonly stripeId?: string,
    readonly subscriptionId?: string,
    readonly plan?: string,
    readonly service?: string,
    readonly roles?: {},
  ) {}

  toString() {
    return this.id;
  }
}

export const SHOP_AUTHORITY = 'shop_authorities';
export const PLAN = {
  MINIMUM: 'minimum',
  NORMAL: 'normal',
  ENTERPRISE: 'enterprise'
}
export const REGISTER_ROUTE_SERVICE = {
  Shopify: "Shopify",
  Web: "Web",
  ByHand: "ByHand"
}
export const ROLES = {
  admin: 'admin',
  member: 'member'
}
export const shopAuthorityConverter: FirestoreDataConverter<ShopAuthority> = {
  toFirestore: (shopAuthority) => {
    return {
      stripeId: shopAuthority.stripeId,
      subscriptionId: shopAuthority.subscriptionId,
      plan: shopAuthority.plan,
      service: shopAuthority.service,
      roles: shopAuthority.roles,
    };
  },

  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options);
    return new ShopAuthority(snapshot.id,
      data.stripeId,
      data.subscriptionId,
      data.plan,
      data.service,
      data.roles,
    );
  }
};
